import { KendoBaseComponent, KendoBaseDatasourceComponent } from '@progress/kendo-base-components-vue-wrapper'
import MultiColumnComboBoxProps from './MultiColumnComboBoxProps'

import KendoMultiColumnComboBoxColumn from './KendoMultiColumnComboBoxColumn'
import Animation from '../Common/Animation'
import Popup from '../Common/Popup'
import Virtual from '../Common/Virtual'

export default {
    emits: {
        'update:modelValue': null,
        'kendowidgetready': null
    },
    props: MultiColumnComboBoxProps,
    mixins: [
        KendoBaseComponent,
        KendoBaseDatasourceComponent,
        Animation,
        Popup,
        Virtual
    ],
    model:{
        event: 'changemodel'
    },
    mounted() {
        var that = this
        var widgetElement = that.$el
        that._resolveChildren()
        kendo.jQuery(this.$el).kendoMultiColumnComboBox(this.widgetOptions)

        if(this.v3) {
            this.ready()
            this.$emit('kendowidgetready', this.kendoWidget())
        } else {
            this.$emit('kendowidgetready', this.kendoWidget())
        }

        that.kendoWidget().bind('change', function(){
            if(that.v3){
                that.$emit('update:modelValue', widgetElement.value)
            } else {
                that.$emit('changemodel', widgetElement.value)
            }
        })
    },
    methods: {
        kendoWidget() {
            var widgetElement = this.$el
            return kendo.jQuery(widgetElement).getKendoMultiColumnComboBox()
        },
        _resolveChildren () {
            this.resolveChildren('columns', KendoMultiColumnComboBoxColumn.name)
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dropdowns-vue-wrapper/src/KendoMultiColumnComboBox/KendoMultiColumnComboBoxMixin.js